/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiescolumnscore2Inputs */

const en_opportunitiescolumnscore2 = /** @type {(inputs: Opportunitiescolumnscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

const de_opportunitiescolumnscore2 = /** @type {(inputs: Opportunitiescolumnscore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score`)
};

/**
* | output |
* | --- |
* | "Score" |
*
* @param {Opportunitiescolumnscore2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiescolumnscore2 = /** @type {((inputs?: Opportunitiescolumnscore2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiescolumnscore2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiescolumnscore2(inputs)
	return de_opportunitiescolumnscore2(inputs)
});
export { opportunitiescolumnscore2 as "opportunitiesColumnScore" }